export const useUpscope = () => window?.Upscope
